import { render, staticRenderFns } from "./PassageAuthoringDialog.vue?vue&type=template&id=3a3a36f4"
import script from "./PassageAuthoringDialog.vue?vue&type=script&lang=ts"
export * from "./PassageAuthoringDialog.vue?vue&type=script&lang=ts"
import style0 from "./PassageAuthoringDialog.vue?vue&type=style&index=0&id=3a3a36f4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports